import { fetchSectionSummaries } from './sectionSummaryLookup';
import { SectionSummary } from './SectionSummary.types';

type SectionSummaryLoaderRenderProps = {
   readonly summaries: SectionSummary[];
};

type SectionSummaryLoaderProps = {
   readonly patientId: number;
   readonly children: (renderProps: SectionSummaryLoaderRenderProps) => JSX.Element | null;
};

export const SectionSummaryLoader = (props: SectionSummaryLoaderProps): JSX.Element | null => {
   // TODO DREGAB-29796: switch to useCqrsGet with LoaderSpinner/Message like MedicalProfileTab.loader.tsx once the query exists
   const summaries = fetchSectionSummaries(props.patientId);

   return props.children({ summaries: summaries });
};
